import { useState } from 'react'
import { Typography, Box, Avatar, Chip, Tooltip, tooltipClasses } from '@mui/material'
import { Circle } from '@mui/icons-material'
import { common } from '@mui/material/colors'

interface Props {
  status: 'Approved' | 'Declined' | 'Pending'
  resolutionReason: string | null
}

export function DuplicateStatusChip (props: Props): JSX.Element {
  const [showTooltip, setShowTooltip] = useState(false)

  let color = ''
  let background = ''
  if (props.status === 'Approved') {
    background = '#9FCEC8'
    color = '#07423B'
  } else if (props.status === 'Declined') {
    background = '#E4AFBB'
    color = '#1B1B1B'
  } else if (props.status === 'Pending') {
    background = '#EFEFEF'
    color = '#595959'
  }

  const onShowTT = (): void => {
    setShowTooltip(true)
  }
  const onHideTT = (): void => {
    setShowTooltip(false)
  }

  return <Box sx={{ display: 'flex', flexDirection: 'row', alignItems: 'center', gap: 1 }}>
    <Chip
      icon={<Circle sx={{ fontSize: 11, color: `${color} !important` }} />}
      label={<Typography sx={{ fontWeight: '600', fontSize: '14px' }}>{props.status}</Typography>}
      variant='outlined'
      sx={{ border: 0, backgroundColor: background, paddingX: '12px' }}
    />
    {props.status === 'Declined' && props.resolutionReason != null &&
      <Tooltip
        title={props.resolutionReason}
        placement='top'
        onClose={onHideTT}
        open={showTooltip}
        arrow
        PopperProps={{
          sx: {
            [`& .${tooltipClasses.arrow}`]: {
              color
            },
            [`& .${tooltipClasses.tooltip}`]: {
              backgroundColor: color
            }
          }
        }}
      >
        <div>
          <Avatar data-testid="toolTipButton" onClick={onShowTT}
            sx={{ bgcolor: common.black, width: '18px', height: '18px', fontSize: '15px', cursor: 'pointer' }}
          >i</Avatar>
        </div>
      </Tooltip>

    }
  </Box>
}
